/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useRef, useState } from "react";
import { graphql, StaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext.jsx";
import Carousel from "~components/Carousel";
import ReviewGrid from "~components/ReviewGrid";
import Img from "gatsby-image";
import Button from "~components/Button";
import Star from "~components/svg/Star";


const ReviewsSection = ({ data }) => {
  const sources = [];
  {data?.reviews?.map((reviewCard, reviewCardIndex) => {
    if(reviewCard.rating == 5 && reviewCard.body!=null && reviewCard.title != null ){
      sources.push(reviewCard);
    }
  })}
  
  //console.log(sources);
  //data.ratingAll
  //data.totalAll
  return (
    <section
      className={`w-full relative block pt-v4 pb-v4 pl-v4 pr-v4 xs:py-10 review-section`}
    >
      <header className="grid" style={{ justifyItems: `center` }}>
        <h3 className={`w-full flex items-center justify-center grid-end-12 mb-v2`}>
          {Array(5)
            .fill(null)
            .map(() => (
              <Star className="float-left big-star" />
            ))}
        </h3>
        <h3 className="grid-end-12 f3 text-center xs:w-5/6">
          4.9 out of 5 stars
        </h3>

        <h3 className="grid-end-6 xs:grid-end-12 grid-start-4 xs:grid-start-1 mt-v1 mb-v2 xs:mt-v4 xs:mb-v3 whitespace-pre-wrap b2 text-center">
          Based on 1000+ reviews
        </h3>
      </header>
      <ReviewGrid
        items={sources.map((reviewCard, reviewCardIndex) => {
          const key = `review-${reviewCardIndex}`;
          return (
            <div 
              key={key} 
              className={`review-border pt-v1 pb-v1 pl-v1 pr-v1`}
            >
              <div className={`starbox`}>
                {Array(reviewCard.rating)
                  .fill(null)
                  .map(() => (
                    <Star className="star-size float-left" />
                  ))}
              </div>
              <p className={`message-title italic VulfSans`}>
                <strong>{ reviewCard.title }</strong>
              </p>
              <p className={`message-text mt-v1 mb-v1 VulfSans`}>"{ reviewCard.body }"</p>
              <p>
                <span className={`message-text VulfSans`}>- { reviewCard.reviewer.name }</span>
                <span className={`verified-border`}>
                  <i className={`iconfont icon-verified`}>&#xe634;</i>
                  Verified Buyer
                </span>
              </p>
            </div>
          );
        })}
        keyPrefix="review"
        withArrows
        withBullets
      />
    </section>
  );
};

export default ReviewsSection;
